import { answeredMapper, calidadDatosMapper, invalidMapper, porcRespuestasMapper } from '../dashHelper'
import { getCommonWidget } from '../dashWidgetHelper'
import { getLineDetailedRadar } from '../widgetsLibrary/widgetsLine'
import { CJ_JAC_ORDER, commonWidgets, getCmID, jacCustomerJourneyMapper, getJacCustomerJourney, 
    postVentaMapperJacCustomerJourney, getJacCustomerJourneyVentaWidget, getJacCalidadDatosWidget, 
    getJacPorcRespuestasWidget, getJacNpsVentaWidget, ventaMapperJacCustomerJourney } from './commonWidgetsJac'
import demoVenta from './demoVenta'

export default {
  title: 'CXO Venta/Postventa Dashboard',
  description: 'Dashboard de CXO Venta/Postventa',
  backgroundClassName: (filters: any) => 'epsilon-hero-bg',
  widgets: (filters: FiltersUI) => [
    /* getLineDetailedRadar({
      mainIndicator: 'CSAT_GENERAL',
      radialIndicators: [
        'CSATVN',
        'entregavn',
        'survey-response-counters',
        'entregapv',
        'recomendacionpv'
      ],
      radialType: 'byIndicator',
      size: [4, 4],
      title: 'widgets.snByGeo',
      extraConfigs: {
        backgroundColor: 'transparent',
        theme: 'dark',
        showRadialChart: true,
      },
      //criticalMomentInclude: [1],
      groupByLevel: 1,
      useNormalizedRadial: false,
      //normalizeBottom: 0,
      //normalizeTop: 100,
      indicatorsNames: {
        'entregavn': 'Satisfacción Venta',
        'CSATVN': 'NPS Venta',
        'survey-response-counters': '% de Respuestas',
        'entregapv': 'Satisfacción Servicio',
        'recomendacionpv': 'NPS Servicio'
      },
    }), */
    {
      title: 'Encuestas',
      type: 'label',
      size: [2, 1],
      config: { color: '#B7AADC' },
    },
    {
      title: 'Alertas',
      type: 'label',
      size: [2, 1],
      config: { color: '#B7AADC' },
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'surveyCountTrendByMonth',
      subTitle: 'widgets.surveyCountMonth',
      size: [1, 2],
      indicator: 'SURVEY_COUNT',
      criticalMomentInclude: [getCmID('venta')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'surveyCountTrendByWeek',
      subTitle: 'widgets.surveyCountWeek',
      size: [1, 2],
      indicator: 'SURVEY_COUNT',
      criticalMomentInclude: [getCmID('venta')],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'alertsTrendByMonth',
      subTitle: 'widgets.alertsCountMonth',
      size: [1, 2],
      indicator: 'ALERT_FIRST_RESPONSE_TIME',
      criticalMomentId: getCmID('venta'),
      extraConfigs: {
        useCurrent: 0,
      }
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'alertsTrendByWeek',
      subTitle: 'widgets.alertsCountWeek',
      size: [1, 2],
      indicator: 'ALERT_FIRST_RESPONSE_TIME',
      criticalMomentId: getCmID('venta'),
      extraConfigs: {
        useCurrent: 0,
      }
    }),
    {
      title: 'labels.venta',
      type: 'label',
      size: [4, 1],
      config: { color: '#B7AADC' },
    },
    getJacNpsVentaWidget(),
    getJacCalidadDatosWidget(getCmID('venta')),
    getJacPorcRespuestasWidget(getCmID('venta')),
    getJacCustomerJourney({
         id: 'multipleGaugeByQuestion',
         title: 'widgets.customerJourneyVenta',
         helpText: '',
         size: [4, 2],
         mapper: ventaMapperJacCustomerJourney,
         extraConfigs: {
           chartRadius: '80%',
           chartCenter: ['50%', '45%'],
           labelFontSize: 40,
           groupNameFormat: 'description',
           maxValue: 100,
           colors: undefined
         },
         indicators: [
           { name: 'VENTA_RECEPCION', formula: 'count-number' },
           { name: 'VENTA_ATENCION', formula: 'count-number' },
           { name: 'VENTA_EXPLICACION', formula: 'count-number' },
           { name: 'VENTA_INSTALACIONES', formula: 'count-number' },
           { name: 'VENTA_ENTREGA', formula: 'count-number' }
         ],
       }),
    //getJacCustomerJourneyVentaWidget(),
    /*getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'multipleGaugeByQuestion',
      title: 'widgets.customerJourneyVenta',
      mapper: jacCustomerJourneyMapper,
      indicator: 'VENTA_CUSTOMER_JOURNEY',
      extraConfigs: {
        chartRadius: '70%',
        groupNameFormat: 'description',
        maxValue: 100
      },
      size: [4, 2],
    }),*/
    {
      title: 'labels.postventa',
      type: 'label',
      size: [4, 1],
    },
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'multipleTrendByMonth',
      title: 'widgets.npsPostventa',
      size: [2, 2],
      indicator: 'recomendacionpv',
      extraConfigs: {
        useCurrent: 0
      }
    }),
    
    getJacCalidadDatosWidget(getCmID('servicio')),
    getJacPorcRespuestasWidget(getCmID('servicio')),
    /*
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'multipleGaugeByQuestion',
      title: 'widgets.customerJourneyPostventa',
      mapper: jacCustomerJourneyMapper,
      extraConfigs: {
        chartRadius: '80%',
        chartCenter: ['50%', '45%'],
        labelFontSize: 40,
        groupNameFormat: 'description',
        maxValue: 100,
      },
      //indicator: 'POSTVENTA_CUSTOMER_JOURNEY',
      indicator: 'MERGE',
      extras: {
        indicators: 'POSTVENTA_CUSTOMER_JOURNEY,Avance_CSI,Reparacion_CSI', 
      },
      size: [4, 2]
    }),
    */
    getJacCustomerJourney({
      id: 'multipleGaugeByQuestion',
      title: 'widgets.customerJourneyPostventa',
      helpText: '',
      size: [4, 2],
      mapper: postVentaMapperJacCustomerJourney,
      extraConfigs: {
        chartRadius: '80%',
        chartCenter: ['50%', '45%'],
        labelFontSize: 40,
        groupNameFormat: 'description',
        maxValue: 100,
        colors: undefined
      },
      indicators: [
        { name: 'Experiencia_CSI', formula: 'count-number' },
        { name: 'Competencia_AS', formula: 'count-number' },
        { name: 'recepcion_CSI', formula: 'count-number' },
        { name: 'Avance_CSI', formula: 'count-number' },
        { name: 'entregapv', formula: 'count-number' },
        { name: 'Reparacion_CSI', formula: 'count-number' },
      ],
    }),

    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'diagramaIshikawa',
      title: 'widgets.ishikawa',
      size: [4, 2],
      indicator: 'SENTIMENT'
    }),
    //==== sentiment analysis
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'textAnalysis',
      title: "widgets.sentimentAnalysisAllCampaigns",
      indicator: 'SENTIMENT',
      size: [4, 3],
    }),
    getCommonWidget({
      commonWidgets: commonWidgets,
      name: 'wordCountWithLinks',
      title: 'Nube de Palabras / Frecuencia en comentarios',
      size: [4, 3],
      criticalMomentInclude: [getCmID('venta'), getCmID('servicio')],
      extraConfigs: {
        symbolSizeMultiplier: 1.5,
        forceGravity: 0.5
      }
    }),
  ],
} as DasboardConfig
